import "./App.css";
import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { StoreContext } from "./context/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getFromLocalStorage,
  removeItem,
  setLocalStorage,
} from "./components/utils/local-storage";
import { resetState } from "./redux/authSlice";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Header from "./components/header/header";
import DefaultPage from "./components/defaultPage";
import { useLocation } from "react-router-dom";
import GamePlay from "./components/pages/casino/GamePlay.js";

const Deposit3 = React.lazy(() =>
  import("./components/pages/deposit-withraw/Deposit3")
);

const BetslipShareDecode = React.lazy(() =>
  import("./components/betslip/BetslipShareDecode")
);

const Jackpot = React.lazy(() => import("./components/Jackpot"));

const Live = React.lazy(() => import("./components/live"));

const HowToPlay = React.lazy(() => import("./components/pages/HowToPLay2"));

const TermsAndConditions = React.lazy(() =>
  import("./components/pages/terms-and-conditions/index")
);

const CookiePolicy = React.lazy(() =>
  import("./components/pages/cookie-policy/index")
);

const DisputeResolution = React.lazy(() =>
  import("./components/pages/dispute-resolution/index")
);

const ResponsibleGambling = React.lazy(() =>
  import("./components/pages/responsible-gambling")
);

const AntimoneyLaundering = React.lazy(() =>
  import("./components/pages/anti-money-laundering")
);

const PrivacyPolicy = React.lazy(() =>
  import("./components/pages/privacy-policy")
);

const Withdraw = React.lazy(() =>
  import("./components/pages/deposit-withraw/Withdraw")
);

const Jiserve = React.lazy(() =>
  import("./components/pages/deposit-withraw/Jiserve")
);
const RedeemPoints = React.lazy(() =>
  import("./components/pages/points/RedeemPoints2")
);

const Signup = React.lazy(() => import("./components/pages/auth/registerTwo"));

const ResetPassword = React.lazy(() =>
  import("./components/pages/auth/reset-password2")
);

const VerifyAccount = React.lazy(() =>
  import("./components/pages/auth/verify-account2")
);

// const MobileApp = React.lazy(() => import('./components/pages/app'))

const ProtectedRoute = React.lazy(() =>
  import("./components/utils/protected-route")
);

const PrintMatches = React.lazy(() => import("./components/pages/downloads"));

// const NewCasino = React.lazy(() => import('./components/pages/new-casino/NewCasino'))

const FPL = React.lazy(() => import("./components/FPL"));

const LeaderBoard = React.lazy(() =>
  import("./components/pages/LeaderBoards/LeaderBoards")
);

const JetxLeaderBoard = React.lazy(() =>
  import("./components/pages/LeaderBoards/JetxLeaderBoards")
);

const SpribeGamePlay = React.lazy(() =>
  import("./components/pages/virtuals/SpribeGamePlay")
);

const SpribeGames = React.lazy(() =>
  import("./components/pages/virtuals/SpribeGames")
);

const SmartSoftPlay = React.lazy(() =>
  import("./components/pages/smart-soft/smart-soft")
);

const SmartPlay = React.lazy(() =>
  import("./components/pages/smart-soft/SmartPlay")
);
// const FaziPlay = React.lazy(() => import('./components/pages/fazi/Index'))
const StpPlay = React.lazy(() => import("./components/pages/stp/Index"));
const Slots = React.lazy(() => import("./components/pages/casino/index.jsx"));
const UserGamseCard = React.lazy(() =>
  import("./components/pages/casino/UserGamesCard.jsx")
);
const CrashLayout = React.lazy(() =>
  import("./components/pages/casino/crash/index.jsx")
);
const GameCrash = React.lazy(() =>
  import("./components/pages/casino/crash/crash_games.jsx")
);
const VirtualsLayout = React.lazy(() =>
  import("./components/pages/casino/virtuals/index.jsx")
);
const GameVirtuals = React.lazy(() =>
  import("./components/pages/casino/virtuals/virtual_games.jsx")
);
const GameGrid = React.lazy(() =>
  import("./components/pages/casino/GameGrid.jsx")
);
const GameCard = React.lazy(() =>
  import("./components/pages/casino/GameCard.jsx")
);

const Promotions = React.lazy(() =>
  import("./components/pages/promotions/Promotions")
);

const LiveScore = React.lazy(() =>
  import("./components/pages/livescore/LiveScore")
);

const PageNotFound = React.lazy(() =>
  import("./components/pages/404/NotFound")
);

const ShaksGamePlay = React.lazy(() =>
  import("./components/pages/shaks/ShaksGamePlay")
);

const Kiron = React.lazy(() => import("./components/pages/Kiron"));

const BetslipPage = React.lazy(() =>
  import("./components/pages/betslip/betslipPage")
);

const Login = React.lazy(() => import("./components/pages/loginTwo"));

const NewProfile = React.lazy(() =>
  import("./components/pages/Accounts/NewProfile")
);

const Promo = React.lazy(() => import("./components/pages/promotions/Promo"));

const BetHistory = React.lazy(() =>
  import("./components/pages/Accounts/component/BetHistory")
);

const Notifications = React.lazy(() =>
  import("./components/pages/Notifications/Index")
);

const AppPromo = React.lazy(() => import("./components/pages/app/AppPromo.js"));

const Logout = () => {
  const { dispatch } = useContext(StoreContext);
  const dispatchRedux = useDispatch();
  let navigate = useNavigate();
  setLocalStorage("user", null);
  dispatchRedux(resetState("user"));
  const out = useCallback(() => {
    // localStorage.clear();
    dispatch({ type: "CLEAR_ALL_ITEMS" }); // Dispatch the action to clear all items

    navigate("/");
  }, [navigate]);

  useEffect(() => {
    out();
  }, [out]);

  return null;
};

const Redirect = () => {
  const { dispatch } = useContext(StoreContext);
  const dispatchRedux = useDispatch();
  let navigate = useNavigate();
  removeItem("user");
  dispatchRedux(resetState("user"));
  const out = useCallback(() => {
    localStorage.clear();
    dispatch({ type: "CLEAR_ALL_ITEMS" }); // Dispatch the action to clear all items
    setTimeout(() => {

    navigate("/login");
    },500)
  }, [navigate]);

  useEffect(() => {
    out();
  }, [out]);

  return null;
};

const RedirectIfLoggedIn = ({ children }) => {
  const user = getFromLocalStorage("user");

  return user?.token ? <Navigate to="/" /> : children;
};

const App = () => {
  // const scrollPosition = useSelector((state) => state.scroll.scroll)
  const location = useLocation();
  // Check if the current route is '/app'
  const isAppPromoPage = location.pathname === "/app";
  const [flag, setFlag] = useState(true);
  // cleanup/unmounting components fix
  useEffect(() => {
    return () => {
      setFlag(false);
    };
  }, []);

  return flag ? (
    <>
      {/* <Header /> */}
      {isAppPromoPage ? null : <Header />}
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="*" element={<Navigate to="/404" />} />
          <Route exact path="/" element={<DefaultPage />} />
          <Route exact path="/highlights" element={<DefaultPage />} />
          <Route exact path="/upcoming" element={<DefaultPage />} />
          <Route exact path="/tomorrow" element={<DefaultPage />} />
          <Route exact path="/countries" element={<DefaultPage />} />
          <Route exact path="/competition/:id" element={<DefaultPage />} />
          <Route
            exact
            path="/competition/:sportid/:categoryid/:competitionid"
            element={<DefaultPage />}
          />
          <Route
            exact
            path="/highlights-competition/competition/:sportid/:categoryid/:competitionid"
            element={<DefaultPage />}
          />
          <Route
            exact
            path="/upcoming-competition/competition/:sportid/:categoryid/:competitionid"
            element={<DefaultPage />}
          />
          <Route
            exact
            path="/tomorrow-competition/competition/:sportid/:categoryid/:competitionid"
            element={<DefaultPage />}
          />

          <Route exact path="/live" element={<DefaultPage />} />
          <Route path="/casino" element={<Slots />}>
            <Route path="" element={<GameCard />} />
            <Route path="user-games/:id" element={<UserGamseCard />} />
            <Route path="provider/:providerId" element={<GameGrid />} />
            <Route path="collection/:collectionId" element={<GameGrid />} />
          </Route>
          <Route path="/crashgames" element={<CrashLayout />}>
            <Route path=":id" element={<GameCrash />} />
          </Route>
          <Route path="/virtualgames" element={<VirtualsLayout />}>
            <Route path=":id" element={<GameVirtuals />} />
          </Route>
          <Route exact path="/jiserve" element={<Jiserve />} />
          <Route exact path="/live/:spid" element={<DefaultPage />} />

          <Route exact path="/match/:id" element={<DefaultPage />} />
          <Route exact path="/match/live/:id" element={<DefaultPage live />} />

          <Route
            exact
            path="/login"
            element={
              <RedirectIfLoggedIn>
                <Login />
              </RedirectIfLoggedIn>
            }
          />
          <Route exact path="/fpl" element={<FPL />} />
          <Route exact path="/share" element={<BetslipShareDecode />} />
          <Route exact path="/livescore" element={<LiveScore />} />
          <Route exact path="/404" element={<PageNotFound />} />
          {/* <Route exact path="/casino" element={<NewCasino/>}/> */}

          <Route exact path="/nare-games/:game" element={<SpribeGamePlay />} />
          <Route exact path="/nare-games" element={<SpribeGames />} />
          <Route exact path="/smart-play" element={<SmartPlay />} />
          {/* <Route exact path="/fazi-play" element={<FaziPlay/>}/> */}
          <Route exact path="/play-game" element={<GamePlay />} />
          <Route exact path="/stp-play" element={<StpPlay />} />
          <Route exact path="/smart-soft" element={<SmartSoftPlay />} />
          <Route exact path="/shaks/:game" element={<ShaksGamePlay />} />
          <Route exact path={"/nare-league"} element={<Kiron />} />
          <Route exact path={"/results"} element={<Kiron />} />
          <Route exact path={"/standing"} element={<Kiron />} />
          <Route
            path={"/bet-history/:betID"}
            element={
              <ProtectedRoute>
                <Kiron />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={"/bet-history"}
            element={
              <ProtectedRoute>
                <Kiron />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path={"/profile"}
            element={
              <ProtectedRoute>
                <NewProfile />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={"/my-bets"}
            element={
              <ProtectedRoute>
                <BetHistory />
              </ProtectedRoute>
            }
          />
           <Route
            exact
            path={"/notifications"}
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route exact path={"/betslip"} element={<BetslipPage />} />
          <Route exact path="/betslip-slip" element={<BetslipPage />} />
          <Route exact path="/betslip-nare" element={<BetslipPage />} />
          <Route exact path="/betslip-jackpot" element={<BetslipPage />} />

          <Route exact path="/jackpot" element={<Jackpot />} />
          <Route exact path="/live1" element={<Live />} />
          <Route exact path="/live1/:spid" element={<Live />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            exact
            path="/anti-money-laundering"
            element={<AntimoneyLaundering />}
          />
          <Route
            exact
            path="/responsible-gambling"
            element={<ResponsibleGambling />}
          />
          <Route
            exact
            path="/dispute-resolution"
            element={<DisputeResolution />}
          />
          <Route exact path="/cookie-policy" element={<CookiePolicy />} />
          <Route
            exact
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route exact path="/how-to-play" element={<HowToPlay />} />
          {/*<Route exact path="/lobby" element={<Lobby/>}/>*/}
          <Route
            exact
            path="/signup"
            element={
              <RedirectIfLoggedIn>
                <Signup />
              </RedirectIfLoggedIn>
            }
          />
          <Route exact path="/leader-board" element={<LeaderBoard />} />
          <Route exact path="/leader-boardx" element={<JetxLeaderBoard />} />
          <Route
            path={"/bet-history/:betID"}
            element={
              <ProtectedRoute>
                <Kiron />
              </ProtectedRoute>
            }
          />
          <Route
            path={"/bet-history"}
            element={
              <ProtectedRoute>
                <Kiron />
              </ProtectedRoute>
            }
          />
          <Route exact path="/reset-password" element={<ResetPassword />} />
          <Route exact path="/verify" element={<VerifyAccount />} />
          <Route exact path="/logout" element={<Logout />} />
          <Route exact path="/redirect" element={<Redirect />} />
          <Route exact path="/print-matches" element={<PrintMatches />} />
          <Route exact path="/promotions" element={<Promotions />} />
          <Route exact path="/promo" element={<Promo />} />
          <Route
            exact
            path="/deposit"
            element={
              <ProtectedRoute>
                <Deposit3 />{" "}
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/withdraw"
            element={
              <ProtectedRoute>
                <Withdraw />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/redeem-points"
            element={
              <ProtectedRoute>
                <RedeemPoints />
              </ProtectedRoute>
            }
          />
          <Route exact path="/app" element={<AppPromo />} />
        </Routes>
      </Suspense>
    </>
  ) : null;
};

export default App;
